import React, { Component } from 'react';
import SummarySectionComponent from './SummarySectionComponent';

const IMPRESSIONS_COLOR = '#009fdb';
const CPM_COLOR = '#f02d5b';
const REVENUE_COLOR = '#49b27b';

const isAdmin = (role) => ['admin', 'report_admin', 'advertiser'].includes(role);
let globalRole = 'publisher';

export default class SummaryComponent extends Component {
    constructor(permissions, props) {
      super()
    }
  
    render() {
      const { loading, totalRevenue, totalImpressions, totalGrossImpressions, averageCPM, slopeRevenue, slopeImpressions, slopeCPM, interceptRevenue,
        interceptImpressions, interceptCPM, minRevenue, minImpressions, minCPM, maxRevenue, maxImpressions, maxCPM, imps, revs, cpms } = this.props;
      return (
  
        <div style={{ display: 'flex', justifyContent: 'space-between', gap: '20px', width: '100%', overflow: 'hidden', paddingBottom: '10px', align: 'center' }} >
  
        <SummarySectionComponent
          title='IMPRESSIONS'
          tooltip='impressions'
          color={IMPRESSIONS_COLOR}
          value={(totalImpressions) ? new Intl.NumberFormat('en-US').format(totalImpressions) : "-"}
          min={(minImpressions) ? new Intl.NumberFormat('en-US', { maximumFractionDigits: 2 }).format(minImpressions) : "-"}
          max={(maxImpressions) ? new Intl.NumberFormat('en-US', { maximumFractionDigits: 2 }).format(maxImpressions) : "-"}
          slope={(slopeImpressions) ? new Intl.NumberFormat('en-US', { maximumFractionDigits: 0 }).format(slopeImpressions) : "-"}
          intercept={(interceptImpressions) ? new Intl.NumberFormat('en-US', { maximumFractionDigits: 0 }).format(interceptImpressions) : "-"}
          graphValues={imps}
          loading={loading}
        />
  
        <SummarySectionComponent
          title={isAdmin(globalRole) ? 'GROSS REVENUE' : 'REVENUE'}
          tooltip='revenue'
          color={REVENUE_COLOR}
          value={(totalRevenue) ? new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', maximumSignificantDigits: 8 }).format(totalRevenue) : "-"}
          min={(minRevenue) ? new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', maximumFractionDigits: 2 }).format(minRevenue) : "-"}
          max={(maxRevenue) ? new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', maximumFractionDigits: 2 }).format(maxRevenue) : "-"}
          slope={(slopeRevenue) ? new Intl.NumberFormat('en-US', { maximumFractionDigits: 2 }).format(slopeRevenue) : "-"}
          intercept={(interceptRevenue) ? new Intl.NumberFormat('en-US', { maximumFractionDigits: 2 }).format(interceptRevenue) : "-"}
          graphValues={revs}
          labelPreFix='$'
          loading={loading}
        />
  
        <SummarySectionComponent
          title='AVERAGE CPM'
          tooltip='average CPM'
          color={CPM_COLOR}
          value={(averageCPM) ? new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', maximumSignificantDigits: 5 }).format(averageCPM) : "-"}
          min={(minCPM) ? new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', maximumFractionDigits: 2 }).format(minCPM) : "-"}
          max={(maxCPM) ? new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', maximumFractionDigits: 2 }).format(maxCPM) : "-"}
          slope={(slopeCPM) ? new Intl.NumberFormat('en-US', { maximumFractionDigits: 8 }).format(slopeCPM) : "-"}
          intercept={(interceptCPM) ? new Intl.NumberFormat('en-US', { maximumFractionDigits: 8 }).format(interceptCPM) : "-"}
          graphValues={cpms}
          labelPreFix='$'
          loading={loading}
        />
  
        </div>
      )
    }
  }